<div
  #glareEl
  class="card-glare"
  [class.card-glare--reduced]="reducedMotion()"
  [style.--glare-core]="glareCore()"
  [style.--glare-soft]="glareSoft()"
  [style.--glare-blend]="glareBlend()"
  aria-hidden="true"
></div>
